<!-- <div class="notification-drawer" style="background-color: whitesmoke; margin-right: 0%; margin-left: 135%;">


  <div class="header">
    <h4>Notifications</h4>
    <button nbButton size="small" status="basic" (click)="markAllAsRead()">
      Mark all as read
    </button>
  </div>

  <div class="tabs">
    <nb-tabset>
      <nb-tab tabTitle="All {{ unreadCount > 0 ? '(' + unreadCount + ')' : '' }}" (select)="activeTab = 'all'"></nb-tab>
      <nb-tab tabTitle="Archived" (select)="activeTab = 'archived'"></nb-tab>
    </nb-tabset>
  </div>

  <div class="content">
    <div *ngIf="notifications.length === 0" class="empty-state">
      <nb-icon icon="bell-off-outline" status="basic" size="large"></nb-icon>
      <p>No notifications</p>
    </div>

    <div *ngFor="let notification of notifications" class="notification-item"
      (click)="onNotificationClick(notification)">
      <div class="icon-wrapper">
        <nb-icon [icon]="getIconForType(notification.type)" status="basic" size="medium"></nb-icon>
      </div>
      <div class="details">
        <div class="title">{{ notification.title }}</div>
        <div *ngIf="notification.description" class="description">{{ notification.description }}</div>
        <div class="timestamp">{{ notification.timestamp }}</div>
        <div *ngIf="notification.avatar" class="avatar">
          <img [src]="notification.avatar" alt="User Avatar" />
        </div>
      </div>
      <div class="actions" *ngIf="notification.actions && notification.actions.length > 0">
        <nb-button *ngFor="let action of notification.actions" size="small" [status]="action.type"
          (click)="onActionClick(action, $event)">
          {{ action.label }}
        </nb-button>
      </div>
      <nb-icon icon="chevron-right-outline" status="basic" size="small" class="chevron"></nb-icon>
    </div>
  </div>
</div> -->



<div class="notification-drawer">
  <div class="header">
    <h4>Notifications</h4>
    <button nbButton size="tiny" status="basic" (click)="markAllAsRead()" *ngIf="unreadCount > 0">
      <nb-icon icon="checkmark-circle-outline"></nb-icon>
    </button>
  </div>

  <div class="tabs">
    <nb-tabset>
      <nb-tab tabTitle="All {{ unreadCount > 0 ? '(' + unreadCount + ')' : '' }}" (select)="activeTab = 'all'"></nb-tab>
      <nb-tab tabTitle="Archived" (select)="activeTab = 'archived'"></nb-tab>
    </nb-tabset>
  </div>

  <div class="content">
    <div *ngIf="notifications.length === 0" class="empty-state">
      <nb-icon icon="bell-off-outline" status="basic"></nb-icon>
      <p>No notifications</p>
    </div>

    <div *ngFor="let notification of notifications; let i = index" 
         class="notification-item"
         [class.unread]="!notification.read"
         [style.animation-delay]="(i * 0.04) + 's'"
         (click)="onNotificationClick(notification)">
      <div class="icon-wrapper" [ngClass]="'type-' + notification.type">
        <nb-icon [icon]="getIconForType(notification.type)"></nb-icon>
      </div>
      <div class="details">
        <div class="title">{{ notification.title }}</div>
        <div *ngIf="notification.message" class="description">{{ notification.message }}</div>
        <div class="timestamp">{{ formatTimestamp(notification.createdAt) }}</div>
      </div>
      <nb-icon icon="chevron-right-outline" class="chevron"></nb-icon>
    </div>
  </div>
</div>